import { useCallback, useMemo } from 'react'
import { generateClient } from 'aws-amplify/api'

import { getHost } from '../graphql/queries'
import { advanceSimYear as advanceSimYearMutation } from '../graphql/mutations'

export const useHost = () => {
  const client = useMemo(() => generateClient(), [])
  const fetchHost = useCallback(
    async (id) => {
      return client.graphql({
        query: getHost,
        variables: { id },
      })
    },
    [client],
  )

  const advanceSimYear = useCallback(
    async (offeringId, toYear) => {
      return client.graphql({
        query: advanceSimYearMutation,
        variables: {
          input: {
            offeringId,
            toYear,
          },
        },
      })
    },
    [client],
  )

  return {
    fetchHost,
    advanceSimYear,
  }
}
